import React from "react";
import { UserAvatarCard } from "./user-avatar";

export function FormHeader({
  title,
  subtitle,
  titleAdornment,
  customClasses = {},
  iconSize = "md",
  icon,
}) {
  const {
    headerContainer = "",
    titleClassName = "",
    subtitleClassName = "",
    iconClassName = "",
  } = customClasses;

  return (
    <div className={`mb-8 flex items-start gap-4 ${headerContainer}`}>
      <UserAvatarCard
        icon={icon}
        iconClassName={iconClassName}
        iconSize={iconSize}
      />
      <div>
        <div className="flex items-center gap-3">
          <h1 className={`text-2xl font-semibold text-gray-900 ${titleClassName}`}>
            {title}
          </h1>
          {titleAdornment}
        </div>
        {subtitle && (
          <p className={`mt-1 text-gray-600 ${subtitleClassName}`}>
            {subtitle}
          </p>
        )}
      </div>
    </div>
  );
}
